export default {
	state: {
		ultimaChave: {}
	},
	getters: {
		"ultimaChave": state => state.ultimaChave
	},
	mutations: {
		setUltimaChave(state, payload) {
			state.ultimaChave = payload
		}
	},
	actions: {
		atualizarEstadoUltimaChave({ commit }, payload) {
			commit('setUltimaChave', payload)
		}
	}
};